import { render, staticRenderFns } from "./DepartmentItem.vue?vue&type=template&id=6e4856aa&scoped=true"
import script from "./DepartmentItem.vue?vue&type=script&lang=js"
export * from "./DepartmentItem.vue?vue&type=script&lang=js"
import style0 from "./DepartmentItem.vue?vue&type=style&index=0&id=6e4856aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4856aa",
  null
  
)

export default component.exports